import { useContext, useEffect, useState } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { buildTarificacionData, bulidDataToSave, buildDataNotification, initPage, setData, paginaAutoCr, planes, getDataEnte2 } from '../../data/cotizadorCrData';
import useToken from '../../hooks/useToken';
import { ImgAlert, ImgNext,ImgError } from '../../svg';
import ControlButton from '../controls/ControlButton';
import Pages from './Pages';
import tarificar, { computeRateResult } from '../../services/tarificar'
import '../../cotizadorcr.css'
import Modal from 'react-modal';
import { customStyles, endPoints, tipoNotificacionEnum } from '../../utils/constanst';
import DivRow from '../controls/DivRow';
import http, { getConfig } from '../../services/http';
import Container from '../Container';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { ImgWaitMail, ImgCotizacionOK } from '../../svg/automovilcr/index';
import { motivoRechazoCICAC } from '../../data/mochaData';
import './cotizadorcr.css';


const CotizadorCR = ({ ...rest }) => {

    const { loading } = useToken();

    useEffect(() => {

        if (!loading) {

            setTimeout(() => {
                const preloader = document.querySelector('.site-preloader');

                if (preloader) {
                    preloader.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'opacity') {
                            preloader.parentNode.removeChild(preloader);
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                }
            }, 600);

        }

    }, [loading]);



    return (
        <Container>
            <div>{!loading &&

                <Layout></Layout>

            }
            </div>
        </Container>
    );
}

const Layout = ({ loading, ...rest }) => {
    const [index, setIndex] = useState(initPage);
    const pages = 11;
    const textNext = index === pages ? 'Finalizar' : 'Siguiente';
    const msg = 'Enviar correo';
    const secondNotification = 3;


    const [seconds, setSeconds] = useState(0);
    const [msgNotification, setMsgNotification] = useState(msg);
    const [modalMailWait, setModalMailWait] = useState(false);
    const [modalOferta, setModalOferta] = useState(false);
    const [modalRiesgo, setModalRiesgo] = useState(false);
    const [catalogosRiesgo, setCatalogosRiesgo] = useState([]);
    const [errorRiesgo, setErrorRiesgo] = useState("");
    const [modalPVError, setModalPVError] = useState(false);
    const valMsgDefault = { showDialog: false, field: '' };
    const [validationObj, setValidationObj] = useState({ ...valMsgDefault });
    const { poliza, setPoliza, tarificacion, setTarificacion, catalogos } = useContext(CotizadorCRDataContext);
    const [ofertaCreada, setOfertaCreada] = useState(false);
    const [descargando, setDescargando] = useState(false);
    const [connection, setConnection] = useState(null);
    const [payRules, setPayRules] = useState({ msgSent: false, acceptedCondition: false });

    const [openModal, setOpenModal] = useState(false);
    const [msgModal, setMsgModal] = useState(false);

    const [useCotizadorV2] = useState(true);

    useEffect(() => {

        const config = getConfig();

        const url = `${config.url_api}${endPoints.notificationHub}`;
        const newConnection = new HubConnectionBuilder()
            .withUrl(url, {
                withHandshakeResponseTimeout: 3000000,
            })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    connection.on('AcceptCondition', (accepted) => {
                        if (accepted) {
                            setPayRules({ ...payRules, acceptedCondition: accepted });
                            setModalMailWait(false);
                            setIndex(paginaAutoCr.paginaPasarela);
                        }
                        else {
                            setModalMailWait(false);
                            setIndex(paginaAutoCr.paginaNoAcepta);
                        }

                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection]);

    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => {
                setSeconds(seconds - 1);
            }, 1000);
        }
        else {
            setPoliza({ ...poliza, sendNotification: false })
        }
    }, [seconds]);




    const decrement = () => {
        let i = index - 1;
        //si es casado saltar pagina
        if (poliza.estadoCivil !== '1' && i === paginaAutoCr.paginaConyuge)
            i--;
        if (index === paginaAutoCr.paginaAutoUsado)
            setIndex(paginaAutoCr.paginaDatosVeh);
        else if (index !== 0)
            setIndex(i);
        else
            back();
    };

    const increment = () => {
        let i = index + 1;
        //si es casado saltar pagina
        if (poliza.estadoCivil !== '1' && i === paginaAutoCr.paginaConyuge)
            i++;
        if (tarificacion.auNuevo === 0 && index === paginaAutoCr.paginaDatosVeh)
            setIndex(paginaAutoCr.paginaAutoUsado)
        else if (paginaAutoCr.paginaAutoUsado === index)
            setIndex(paginaAutoCr.paginaAutoUsadoFinal)
        else if (index !== pages) {
            setIndex(i);
        }
    }

    const back = () => {
        rest.history.push('/', { data: null });
    }

    const execute = i => {

        return new Promise((resolve, reject) => {
            switch (i) {
                case 0:
                    execTarificacion(resolve, reject);
                    break;
                case 1:
                    execCrearOferta(resolve, reject);
                    break;
                case paginaAutoCr.paginaDatosPersonales:
                    const evaluacionRiesgo = ExisteRiesgo(poliza.profesion, poliza.nacionalidad);
                    if(evaluacionRiesgo.existeRiesgo){
                        guardarDatosPersonales();
                        setModalRiesgo(true);
                        if(evaluacionRiesgo.tiposRiesgo.includes("nacionalidad"))
                            {
                                sendNotificationAuto(tipoNotificacionEnum.RechazoPorNacionalidad);
                            }
                        if(evaluacionRiesgo.tiposRiesgo.includes("profesion"))
                                {
                                sendNotificationAuto(tipoNotificacionEnum.RechazoPorOcupacionActividad);
                                }
                    
                    }
                    else{
                        sendNotificationAuto(tipoNotificacionEnum.DocumentoIdentidad);
                        increment();
                        guardarPaginaDatosPersonales();
                    }  
                          
                    break;
                case paginaAutoCr.paginaActividadEconomica:
                    guardarPaginaDatosPersonales();
                    break;    
                case paginaAutoCr.paginaDatosVeh:
                    UpdatePolicy();
                    sendNotificationAuto(tipoNotificacionEnum.FacturaProforma);
                    break;
                case 7:
                    execNotification();
                    break;
                case paginaAutoCr.paginaPasarela:
                    execPayment2();
                    break;
                case paginaAutoCr.paginaAutoUsado:
                    //sendNotificationAuto(tipoNotificacionEnum.InspeccionVehiculo)
                    sendFotosAutoUsado2();                   
                    break;
                case paginaAutoCr.paginaFatcaCicac:
                    // if (poliza.CICACGuardado === true)
                    //     increment();
                    // else
                    addCICAC();
                    break;
                default:
                    resolve({});
                    break;
            }
        })
    }

    const ExisteRiesgo = ( profesion, nacionalidad) => {

        const paisesRiesgo = catalogosRiesgo.filter(x => x.idMaestro == "nacionalidad").map(x => x.valor);
        const profesionesRiesgo = catalogosRiesgo.filter(x => x.idMaestro == "profesion").map(x => x.valor);
        let tiposRiesgo=[];
        if(profesionesRiesgo.includes(profesion)){
            setErrorRiesgo("La profesion del ente se encuentra entre los paises de riesgo");
           tiposRiesgo.push("profesion");
        }

        if(paisesRiesgo.includes(nacionalidad)){
            setErrorRiesgo("La nacionalidad del ente se encuentra entre los paises de riesgo");
           tiposRiesgo.push("nacionalidad");
        }

        if(tiposRiesgo.length>0)
            {
                setErrorRiesgo(`El ente se encuentra entre las categorias de riesgo debido a:${tiposRiesgo.join(", ")}`);
                return{existeRiesgo:true,tiposRiesgo:tiposRiesgo}
            }
            else{
                setErrorRiesgo("");
                return {existeRiesgo:false,tiposRiesgo:tiposRiesgo} 
            }
        
    }

    const UpdatePolicy = () => {

        let data = bulidDataToSave(poliza, tarificacion, catalogos);
        setPoliza({ ...poliza, loading: true });
        http(endPoints.updateAutoPolicy).post(data)
            .then(() => {
                if (poliza.auFiles != null) {
                    if (poliza.auFiles['1'] !== null)
                        sendNotificationAuto(tipoNotificacionEnum.FacturaEquiposEspeciales);
                }
                setPoliza({ ...poliza, loading: false })
                increment()

            })
            .catch(() => setPoliza({ ...poliza, loading: false }))
            .finally(() => setPoliza({ ...poliza, loading: false }));
    }

    const guardarPaginaDatosPersonales = () => {
        setPoliza({ ...poliza, loading: true });
        Promise.allSettled([
            ActualizarDatosAsegurado(),
            sendNotificationAuto2(tipoNotificacionEnum.DocumentoIdentidad)
        ]).then(() => {
            setPoliza({ ...poliza, loading: false });
            increment();
        } )
    }

    const guardarDatosPersonales = () => {
        setPoliza({ ...poliza, loading: true });
        Promise.allSettled([
            ActualizarDatosAsegurado(),
            sendNotificationAuto2(tipoNotificacionEnum.DocumentoIdentidad)
        ]).then(() => {
            setPoliza({ ...poliza, loading: false });
        } )
    }

    const ActualizarDatosAsegurado = () => {
        const data = getDataEnte2(poliza);
        return http(endPoints.updateEnte).post(data);
    }


    const execNotification = async (resolve, reject) => {
        if (!payRules.acceptedCondition) {

            let data = {
                Nombre: poliza.asegurado.nombre,
                Correo: poliza.asegurado.email,
                IdPoliza: poliza.id //465338//poliza.id
            }

            setPoliza({ ...poliza, loading: true });

            http(endPoints.sendAcceptNotification).post(data)
                .then(result => {
                    http(endPoints.associateConnetion(result.message)).get().then(() => {
                        connection?.invoke("AssociateConnetion", result.message);
                        setModalMailWait(true);
                    }).catch(() => {
                        setPoliza({ ...poliza, loading: false });
                    })
                        .finally(() => {
                            setPoliza({ ...poliza, loading: false });
                        })

                }).catch(error => {
                    setPoliza({ ...poliza, loading: false });
                });
        }
        else {
            increment();
        }

    }

    const execTarificacion = (resolve, reject) => {
        let data = buildTarificacionData(poliza.planId, tarificacion);
        setTarificacion(data);


        const tarificarPlan = tarificar(poliza.planId);
        setPoliza({ ...poliza, loading: true });
        tarificarPlan(data).then(resp => {

            setPoliza(computeRateResult(poliza, resp.rates));

            resolve(resp);

        }).catch(error => {

            setTarificacion({ showDialogFail: true, errorMsg: error });
            setPoliza({ ...poliza, loading: false });
            reject(error);
        })
        // .finally(() =>  setPoliza({...poliza, loading: false}));
    }

    const execCrearOferta = (resolve, reject) => {
        if (!ofertaCreada) {
            setOfertaCreada(true);
            crearOferta();
        }
        if (useCotizadorV2)
            setModalOferta(true);
        else
            openModalFinish();


    }

    const addCICAC = () => {

        let motivoAceptacion = '';

        if (poliza.aceptaCICAC === false) {
            let cat = motivoRechazoCICAC.find(x => x.value === poliza.motivoid);
            if (cat !== undefined)
                motivoAceptacion = cat.text;
        }

        let data = {
            "enteId": poliza.aseguradoId,
            "acepta": poliza.aceptaCICAC,
            "idMotivoNoAceptacion": poliza.motivoid,
            "motivoNoAceptacion": motivoAceptacion
        }
        setPoliza({ ...poliza, loading: true });
        http(endPoints.addCICAC).post(data)
            .then(() => {
                console.log('guardado')
                setPoliza({ ...poliza, CICACGuardado: true, loading: false })
            })
            .catch(() => setPoliza({ ...poliza, loading: false }))
            .finally(() => { increment(); });
    }


    const execPayment2 = () => {
        const data = {
            policyId: poliza.id,
            cardHolder: poliza.pasarela.cardHolder,
            cardNumber: poliza.pasarela.cardNumber.cardNumber,
            cvv: poliza.pasarela.cvv,
            expirationDate: poliza.pasarela.expirationDate,
            amountApp: getAmount(),
            currencyApp: getCurrencyProvider(),
            email: poliza.asegurado.email
        };
        setOpenModal(true);
        setMsgModal("Procesando pago...");

        http(endPoints.paymentPay).post(data)
            .then(idPayment => {
                setMsgModal("Emitiendo poliza...");
                http(endPoints.emissions(poliza.id)).get()
                    .then(resEmision => {
                        let dataUpdate = {
                            idPayment: idPayment,
                            cnpoliza: resEmision.policy
                        }
                        setMsgModal("Actualizando poliza...");
                        http(endPoints.paymentUpdate2).put(dataUpdate)
                            .then(resUpdate => {
                                setMsgModal("Aplicando pago...");
                                http(endPoints.paymentApplyPayment(idPayment)).get()
                                    .then(x => {
                                        setIndex(paginaAutoCr.StepDebitoAutomatico);
                                        setOpenModal(false);
                                        setPoliza({ ...poliza, statusAccount: x.estadoCuenta, transactionId: x.transactionId })
                                    });
                            }).catch(errUpdate => {
                                setModalPVError(true);
                                setOpenModal(false)
                            });

                    }).catch(() => {
                        http(endPoints.paymentRevert(idPayment).get())
                            .then(resRevert => {
                                setModalPVError(true);
                                setOpenModal(false)
                            }).catch(errRevert => {
                                setModalPVError(true);
                                setOpenModal(false)
                            });
                    })
            })
            .catch(error => {
                setModalPVError(true);
                setOpenModal(false)
            });
    }


    const handleSubmit = async (e) => {

        let result = document.querySelector('form').reportValidity();

        if (index === 1 && (catalogosRiesgo === null || catalogosRiesgo?.length < 1)){
            http(endPoints.catalogRiesgo).get().then((res) => {
                setCatalogosRiesgo(res)
            })
            .catch((err) => console.error(err))
        }

        if (index === 7) {
            if (result) {
                if (!poliza.showCaptchaValidation) {
                    await execute(index);
                    increment(true);
                }
                else {
                    if (poliza.captcha == null) {
                        setValidationObj({ showDialog: true, field: 'Seleccione la casilla no soy un robo' });
                        return false;
                    }
                }
            }

        }
        else if (result && validateSelects()) {
            await execute(index);
            increment(true);
        }
    }

    const validateSelects = () => {

        if (setData)
            return true;

        if (poliza.ncuotas == null) {
            setValidationObj({ showDialog: true, field: 'Frecuencia de pago' });
            return false;
        }

        if (tarificacion.marc == null || tarificacion.marc <= 0) {
            setValidationObj({ showDialog: true, field: 'Marca' });
            return false;
        }

        if (tarificacion.dedu == null || tarificacion.dedu <= 0) {
            setValidationObj({ showDialog: true, field: 'Deducibles' });
            return false;
        }

        if (tarificacion.mode == null || tarificacion.mode < 0) {
            setValidationObj({ showDialog: true, field: 'Modelo' });
            return false;
        }

        if (tarificacion.anio == null || tarificacion.anio <= 0) {
            setValidationObj({ showDialog: true, field: 'Año' });
            return false;
        }

        if (tarificacion.usoo == null) {
            setValidationObj({ showDialog: true, field: 'Uso del Vehículo' });
            return false;
        }
        return true;
    }

    const openModalFinish = () => setPoliza({ ...poliza, showDialogFinish: true });
    const closeModalFinish = () => setPoliza({ ...poliza, showDialogFinish: false });

    const crearOferta = () => {
        let data = bulidDataToSave(poliza, tarificacion, catalogos);
        setPoliza({ ...poliza, loading: true });
        http(endPoints.createCotizadorCr).post(data).then(r => {
            setPoliza({ ...poliza, id: r.id, loading: false, aseguradoId: r.asegurado });
            sendWelcome(r.id, data.asegurado);
        }).catch(error => {
            setPoliza({ ...poliza, loading: false });
        });
    }

    const descargarCotizacion = () => {

        setDescargando(true);
        http(endPoints.descargarOferta(poliza.id)).get().then(blob => {
            setDescargando(false);
        });

    }

    const closeTarificacionFail = () => setTarificacion({ showDialogFail: false, errorMsg: '' });

    const closeModalRiesgo = () => {
        setModalRiesgo(false);
        finalizar();
    }

    const sendWelcome = (polizaId, data) => {

        http(endPoints.welcomeNotificationCR(polizaId)).post(data);
    }

    const sendFotosAutoUsado = async () => {
        setPoliza({ ...poliza, loading: true });
        await sendNotificationAuto(tipoNotificacionEnum.InspeccionVehiculo).finally(() => setPoliza({ ...poliza, loading: false }));

    }

    const sendFotosAutoUsado2 = async () => {
        setPoliza({ ...poliza, loading: true });
        await sendNotificationAuto(tipoNotificacionEnum.InspeccionVehiculo).then(() => setIndex(paginaAutoCr.paginaAutoUsadoFinal)).finally(() =>{ 
            setPoliza({ ...poliza, loading: false    })
        })

    }

    const sendNotificationAuto = async (tipo) => {
        let data = await buildDataNotification(poliza, tipo);
        const files = data.adjuntos;
        delete data.adjuntos;
        await http(endPoints.notificationAutoCR)
            .multipleFileData(data, files);
    }

    const sendNotificationAuto2 = async (tipo) => {
        let data = await buildDataNotification(poliza, tipo);
        const files = data.adjuntos;
        delete data.adjuntos;
        return http(endPoints.notificationAutoCR)
            .multipleFileData(data, files);
    }

    const finalizar = () => {
        window.location.href = '/ProductosDigitales/micrositio/automovilcr';
    }

    const navDebitoAutomatico = () => {
        window.location.href = '/ProductosDigitales/micrositio/audebitoautomaticocr';
    }

    const continuarDatos = () => {
        closeModalFinish();
        setModalOferta(false)
        increment(true);
    }

    const getAmount = () => {

        switch (poliza.frecuenciaPagos) {
            case '1'://Anual
                return poliza.primaAnual;
            case '2': //Semestral
                return poliza.primaSemestral;
            case '4': //Trimestral
                return poliza.primaTrimestral;
            case '12'://Mensual
                return poliza.primaMensual;
            default: return 0;
        }
    }

    const getCurrencyProvider = () => ((poliza.planId === planes.planDolares) ? 'U$' : '¢')



    return (
        <div className="layoutcr">
            {(paginaAutoCr.paginaNoAcepta !== index && paginaAutoCr.StepDebitoAutomatico !== index) &&
                <div className="header-section">
                    <h2 className="txt-esmeralda txt-light text-center">¡Calcule su seguro ahora!</h2>
                    <h3 className="txt-light text-center" style={{ paddingLeft: '22px', paddingRight: '22px' }}>Con su póliza de Automóvil LAFISE Plus<br /> disfrute cada momento sin preocupaciones</h3>
                </div>
            }

            <form className="d-grid">
                <Pages indexProgress={index} />
                <ControlButton>

                    <button className={`control-button-btn prev`}
                        type="button"
                        onClick={decrement} style={{ visibility: (index !== 0 && (index !== paginaAutoCr.paginaAutoUsadoFinal && index !== paginaAutoCr.paginaNoAcepta && index !== paginaAutoCr.StepDebitoAutomatico)) ? 'visible' : 'hidden' }} >Regresar</button>



                    {(index < pages && (index !== paginaAutoCr.paginaAutoUsado && index !== paginaAutoCr.paginaAutoUsadoFinal)) &&
                        <button className="control-button-btn next btn-next-notification"
                            type="button"
                            onClick={handleSubmit}
                        >
                            {textNext}
                            {index !== pages && <ImgNext />}
                        </button>
                    }

                    {index === paginaAutoCr.paginaAutoUsado &&
                        <button className="control-button-btn next btn-next-notification"
                            type="button"
                            onClick={handleSubmit}
                        >
                            Contacteme
                            <ImgNext />
                        </button>
                    }

                </ControlButton>
                <Modal
                    isOpen={poliza.showDialogFinish}
                    onRequestClose={closeModalFinish}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    ariaHideApp={false}
                    className='modal-cotizadorcr'
                >

                    <div>
                        <div className="dialog-center-content">
                            <h2 className="text-center txt-primary modal-lbl-t1">¡Su cotización esta lista!</h2>
                        </div>
                        <div className="dialog-center-content">
                            <ImgCotizacionOK />
                        </div>
                        <div className="dialog-center-content">
                            <p className="text-center txt-muted txt-ft-12">Un ejecutivo de Seguros LAFISE se comunicará con usted lo antes posible, o bien nos puede contactar en nuestra central telefónica 2246-2700, estamos para servirle de 8:00 a.m. a 5 p.m. de lunes a viernes.</p>
                        </div>
                        <div className="mt-50"></div>
                        <div className="step">
                            <DivRow width="50%">
                                <div className="dialog-center-content">
                                    <button type="button" className="control-button-btn btn-color-secondary" onClick={descargarCotizacion} disabled={poliza.id === 0 || descargando}>
                                        {poliza.id === 0 ? 'Creando Cotización...' : (descargando ? '' : 'Descargar Cotización')}
                                        {poliza.id !== 0 && descargando ? 'Descargando Cotización...' : ''}
                                    </button>
                                </div>
                            </DivRow>
                            <DivRow width="50%">
                                <div className="dialog-center-content">

                                    <button type="button" className="control-button-btn btn-color-primary" onClick={finalizar}>Finalizar</button>
                                    {/* <button type="button" className="control-button-btn btn-color-primary" onClick={continuarDatos} disabled={poliza.id === 0}>Continuar</button> */}
                                </div>
                            </DivRow>
                        </div>


                    </div>

                </Modal>
                {/*modal nuevo para descargar cotizacion*/}
                <Modal
                    /* isOpen={poliza.showDialogFinish}*/
                    isOpen={modalOferta}
                    onRequestClose={closeModalFinish}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    ariaHideApp={false}
                    className='modal-cotizadorcr'
                >

                    <div>
                        <div className="dialog-center-content">
                            <h2 className="text-center txt-primary modal-lbl-t1">¡Su cotización esta lista!</h2>
                        </div>
                        <div className="dialog-center-content mt-20 mb-20">
                            <ImgCotizacionOK />
                        </div>
                        <div className="">
                            <p className="txt-muted">Has completado el formulario de cotización. Hacé clic en <strong>"Continuar."</strong> Para finalizar la compra de tu póliza, vas a necesitar:</p>

                            <p className="txt-muted">
                                •Fotografías de identificación (Frontal/trasera) <br />
                                •Fotografias del vehiculo <br />
                                •Documentos del vehículo <br />
                                •Tarjeta débito / crédito <br />
                            </p>
                            <p className="txt-muted">Si no deseas continuar hacé clic en <strong>"Contáctame"</strong>  y un ejecutivo de Seguros LAFISE se comunicará con vos lo antes posible.</p>
                        </div>
                        <div className="mt-50"></div>
                        <div className='mt-20 mb-20 center'>
                            <button type="button" className="control-button-btn btn-color-secondary btn-cotizadorcr" onClick={descargarCotizacion} disabled={poliza.id === 0 || descargando}>
                                {(descargando ? '' : 'Descargar Cotización')}
                                {poliza.id !== 0 && descargando ? 'Descargando Cotización...' : ''}
                            </button>
                        </div>
                        <div className="step">
                            <DivRow width="50%">
                                <div className="dialog-center-content">
                                    <button type="button" className="control-button-btn btn-color-primary btn-cotizadorcr btn-cotizadorcr-2" onClick={descargarCotizacion} disabled={poliza.id === 0 || descargando}>
                                        Contactenme
                                    </button>
                                </div>
                            </DivRow>
                            <DivRow width="50%">
                                <div className="dialog-center-content">
                                    <button type="button" className="control-button-btn btn-color-primary btn-cotizadorcr btn-cotizadorcr-2" onClick={continuarDatos} disabled={poliza.id === 0}>Continuar</button>
                                    {/* <button type="button" className="control-button-btn btn-color-primary" onClick={finalizar}>Finalizar</button> */}
                                </div>
                            </DivRow>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={modalPVError} style={customStyles} shouldCloseOnOverlayClick={false}>
                    <h3 className="txt-center" style={{ color: '#FF0000' }}>
                        ¡Ha ocurrido un error!
                    </h3>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <div style={{ padding: '10%' }}>
                        <h5 className="txt-muted">
                            No hemos podido procesar su solicitud, actualice su método de pago o proporcione otro e inténtelo nuevamente.
                        </h5>
                        <h5 className="txt-muted">
                            Si desea que un ejecutivo de Seguro LAFISE lo contante para continuar con la gestión vía telefónica de clic en ¨Contáctenme¨
                        </h5>
                    </div>
                    <div className='dialog-center-content' style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <button type="button" style={{ background: '#EBEBEB', color: '#4D4D4D' }} className="control-button-btn" onClick={() => setModalPVError(false)}>Reintentar</button>
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeTarificacionFail}>Contacteme</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={tarificacion.showDialogFail}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <h2 className="txt-primary txt-center">
                        Se nos ha presentado un inconveniente
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted txt-center">Ha ocurrido un error al calcular la tarifa.<br />
                        {tarificacion.errorMsg}
                    </h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeTarificacionFail}>Entendido</button>
                    </div>
                </Modal>
                <Modal isOpen={modalRiesgo}
                    style={customStyles} contentLabel="Example Modal" ariaHideApp={false}
                    shouldCloseOnOverlayClick={false}
                >
                    <h3 className="txt-muted txt-center">Un ejecutivo de Seguros LAFISE se comunicará con usted lo antes posible<br />
                    </h3>
                    <br/><br/>
                    <div className="dialog-center-content">
                        <ImgError />
                    </div>
                    <br/><br/><br/>
                    <div className="dialog-center-content">
                        
                        <button className="control-button-btn next btn-next-notification"
                            style={{display:'inline-flex'}}
                            type="button"
                            onClick={closeModalRiesgo}
                        >
                            Finalizar
                            <ImgNext />
                        </button>
                    </div>
                 
      
                </Modal>
                {/* Mensaje de validaciòn */}
                <Modal
                    isOpen={validationObj.showDialog}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <h2 className="txt-primary txt-center">
                        Ingrese todos los datos.
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted txt-center">Especifique un valor para el campo: <br />
                        <strong> {validationObj.field}</strong>
                    </h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={() => setValidationObj({ ...valMsgDefault })}>Entendido</button>
                    </div>
                </Modal>
                <Modal className="modal" isOpen={poliza.loading} show={poliza.loading} ariaHideApp={false}>
                    <div className="dialog-center-content-ca">
                        <p className="text-center">Cargando...</p>
                    </div>
                </Modal>
                <Modal className="modal-cotizador-c modal-mail" isOpen={modalMailWait} show={modalMailWait} ariaHideApp={false}>
                    <div>
                        <p className="text-center lbl-color-secondary modal-lbl modal-lbl-t1 mt-50">Esta a un paso de su nueva póliza</p>
                    </div>
                    <div className='img-wm' >
                        <ImgWaitMail />
                    </div>
                    <div className="">
                        <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">Favor revisar su correo electrónico para la aceptación o rechazo de los documentos de tu póliza, posterior retorne a esta página para continuar con la emisión de su póliza</p>
                    </div>
                </Modal>
                <Modal className="modal" isOpen={openModal} show={openModal} ariaHideApp={false}>
                    <div className="dialog-center-content-ca">
                        <p className="text-center">{msgModal}</p>
                    </div>
                </Modal>
            </form>
        </div>
    );
}

export default CotizadorCR;
